export default function CedarRapidsHelpfulResourcesSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Resources</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Helpful Resources for Cedar Rapids Travelers
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Quick links and local info for Cedar Rapids passport applicants.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <div className="bg-white rounded-lg p-6 border border-gray-200">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8] mb-4">
              <i className="ri-camera-line text-[#1A365D] text-lg"></i>
            </div>
            <h3 className="font-bold text-[#1A365D] text-sm mb-2">Passport Photos in Cedar Rapids</h3>
            <p className="text-gray-500 text-sm leading-relaxed mb-3">
              CVS, Walgreens, and UPS Store locations are available throughout the Cedar Rapids metro. Most offer walk-in passport photo service.
            </p>
            <div className="flex flex-wrap gap-2">
              <a href="https://www.cvs.com/store-locator/" target="_blank" rel="noopener noreferrer nofollow" className="text-xs text-[#1A365D] hover:text-[#F6C344] font-medium underline underline-offset-2">CVS</a>
              <a href="https://www.walgreens.com/storelocator" target="_blank" rel="noopener noreferrer nofollow" className="text-xs text-[#1A365D] hover:text-[#F6C344] font-medium underline underline-offset-2">Walgreens</a>
              <a href="https://www.theupsstore.com/tools/find-a-store" target="_blank" rel="noopener noreferrer nofollow" className="text-xs text-[#1A365D] hover:text-[#F6C344] font-medium underline underline-offset-2">UPS Store</a>
            </div>
          </div>

          <div className="bg-white rounded-lg p-6 border border-gray-200">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8] mb-4">
              <i className="ri-flight-takeoff-line text-[#1A365D] text-lg"></i>
            </div>
            <h3 className="font-bold text-[#1A365D] text-sm mb-2">The Eastern Iowa Airport (CID)</h3>
            <p className="text-gray-500 text-sm leading-relaxed mb-3">
              2121 Arthur Collins Pkwy SW, Cedar Rapids, IA 52404. Eastern Iowa's main airport with connections to international hubs through Chicago, Denver, and Dallas.
            </p>
            <a href="https://www.flycid.com/" target="_blank" rel="noopener noreferrer nofollow" className="text-xs text-[#1A365D] hover:text-[#F6C344] font-medium underline underline-offset-2">Visit CID Airport</a>
          </div>

          <div className="bg-white rounded-lg p-6 border border-gray-200">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8] mb-4">
              <i className="ri-file-list-3-line text-[#1A365D] text-lg"></i>
            </div>
            <h3 className="font-bold text-[#1A365D] text-sm mb-2">Iowa Vital Records</h3>
            <p className="text-gray-500 text-sm leading-relaxed mb-3">
              Need a certified birth certificate for your first passport? Order through the Iowa Department of Public Health Bureau of Health Statistics.
            </p>
            <a href="https://idph.iowa.gov/health-statistics/vital-records" target="_blank" rel="noopener noreferrer nofollow" className="text-xs text-[#1A365D] hover:text-[#F6C344] font-medium underline underline-offset-2">Order Birth Certificate</a>
          </div>

          <div className="bg-white rounded-lg p-6 border border-gray-200">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8] mb-4">
              <i className="ri-truck-line text-[#1A365D] text-lg"></i>
            </div>
            <h3 className="font-bold text-[#1A365D] text-sm mb-2">Overnight Shipping from Cedar Rapids</h3>
            <p className="text-gray-500 text-sm leading-relaxed mb-3">
              FedEx, UPS, and USPS Priority Mail Express locations are available throughout the Cedar Rapids metro for overnight document shipping.
            </p>
            <div className="flex flex-wrap gap-2">
              <a href="https://www.fedex.com/en-us/shipping/store/locator.html" target="_blank" rel="noopener noreferrer nofollow" className="text-xs text-[#1A365D] hover:text-[#F6C344] font-medium underline underline-offset-2">FedEx</a>
              <a href="https://www.theupsstore.com/tools/find-a-store" target="_blank" rel="noopener noreferrer nofollow" className="text-xs text-[#1A365D] hover:text-[#F6C344] font-medium underline underline-offset-2">UPS</a>
            </div>
          </div>

          <div className="bg-white rounded-lg p-6 border border-gray-200">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8] mb-4">
              <i className="ri-government-line text-[#1A365D] text-lg"></i>
            </div>
            <h3 className="font-bold text-[#1A365D] text-sm mb-2">U.S. State Department Passport Info</h3>
            <p className="text-gray-500 text-sm leading-relaxed mb-3">
              Official government source for passport forms, fees, processing times, and travel advisories.
            </p>
            <a href="https://travel.state.gov/content/travel/en/passports.html" target="_blank" rel="noopener noreferrer nofollow" className="text-xs text-[#1A365D] hover:text-[#F6C344] font-medium underline underline-offset-2">State Dept. Passport Portal</a>
          </div>

          <div className="bg-white rounded-lg p-6 border border-gray-200">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8] mb-4">
              <i className="ri-phone-line text-[#1A365D] text-lg"></i>
            </div>
            <h3 className="font-bold text-[#1A365D] text-sm mb-2">Contact Fast Passport Center</h3>
            <p className="text-gray-500 text-sm leading-relaxed mb-3">
              Talk to a real human about your Cedar Rapids passport needs. Available Monday through Friday, 9am–6pm.
            </p>
            <a href="tel:8772530084" className="text-xs text-[#1A365D] hover:text-[#F6C344] font-medium underline underline-offset-2">877-253-0084</a>
          </div>
        </div>
      </div>
    </section>
  );
}